module.exports = __webpack_public_path__ + "media/notice2.6f9851d4.mp3";